import React from 'react';
import BaseDashboardLayout from './BaseDashboardLayout';
import { bridgeItems } from '../components/sidebar/items/bridgeItems';

const BridgeLayout = ({ children, width }) => {
	return <BaseDashboardLayout children={children} width={width} navItems={bridgeItems} />;
};

export default BridgeLayout;
